import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useStore } from '@mcn-platform/models';
// eslint-disable-next-line import/no-cycle
import HeaderWithPagination from '../headerWithPagination/HeaderWithPagination';
import MediaCard from './card/MediaCard';
import getData from '../../item/getData';
const RecommendedCourses = ({ categoryId, settings }) => {
    const [page, setPage] = React.useState(1);
    const store = useStore();
    const [category, setCategory] = useState(undefined);
    useEffect(() => {
        setCategory(store.currentPortal?.getCategory(categoryId));
    }, [store.currentPortal, categoryId]);
    return (_jsx(Box, { children: category && settings.showHeader && (_jsxs(_Fragment, { children: [_jsx(HeaderWithPagination, { labelText: "RECOMMENDED COURSES", labelInfo: "", currentPage: page, setPage: (newPage) => setPage(newPage), pageCount: Math.ceil(category.courses.length / 2), settings: { ...settings }, isMobileView: false }), _jsx(Stack, { direction: "row", spacing: 2, sx: { my: 2 }, children: category.courses
                        && category.courses.slice(2 * (page - 1), 2 * page)?.map((course) => (_jsx(MediaCard, { courseData: course }, course.id))) })] })) }));
};
RecommendedCourses.defaultProps = {
    settings: {
        coursesCount: undefined,
        showHeader: true,
        showHeaderTitle: true,
        showHeaderActions: true,
    },
};
RecommendedCourses.getData = getData;
RecommendedCourses.meta = {
    group: 'hidden',
    name: 'Recommended courses',
    description: 'Component displays the recommended courses in course view page.',
    props: [
        {
            key: 'categoryId',
            name: 'Category',
            type: 'category', // note this is a special type recognized by the system
            description: 'Category or group to display courses from',
        },
        {
            key: 'settings.showHeader',
            name: 'Show header',
            type: 'boolean',
            description: 'Display pagination header of recommended courses.',
        },
        {
            key: 'settings.showHeaderTitle',
            name: 'Show title',
            type: 'boolean',
            description: 'Display pagination header title of recommended courses.',
        },
        {
            key: 'settings.showHeaderActions',
            name: 'Show actions',
            type: 'boolean',
            description: 'Display pagination header actions of recommended courses.',
        },
        {
            key: 'settings.coursesCount',
            name: 'Courses count',
            type: 'number',
            description: 'Display limit for recommended courses.',
        },
    ],
    defaultConfig: {
        type: 'component',
        component: 'RecommendedCourses',
        props: {
            settings: {
                showHeader: true,
                showHeaderTitle: true,
                showHeaderActions: true,
                coursesCount: undefined,
            },
        },
    },
};
export default RecommendedCourses;
//# sourceMappingURL=RecommendedCourses.js.map